module.exports = __webpack_public_path__ + "img/logo-levelup-letras.ba9106d5.svg";